import { createSlice } from '@reduxjs/toolkit'

export const layoutControlSlice = createSlice({
    name: 'layoutControl',
    initialState: {
        openDrawerLeft: true, // drgMgtSlice
        openDrawerRight: false, // openRightSideSlice
        openPreviewDRG: false, // openPreviewDRGSlice
        openSimulatorDRG: false, // openSimulatorDRGSlice
        openSimulatorPolicy: false, // openSimulatorPolicySlice
    },
    reducers: {
        setOpenDrawerLeft: (state, action) => {
            state.openDrawerLeft = action.payload;
        },
        setOpenDrawerRight: (state, action) => {
            state.openDrawerRight = action.payload;
        },
        setOpenPreviewDRG: (state, action) => {
            state.openPreviewDRG = action.payload;
        },
        setOpenSimulatorDRG: (state, action) => {
            state.openSimulatorDRG = action.payload;
        },
        setOpenSimulatorPolicy: (state, action) => {
            state.openSimulatorPolicy = action.payload;
        },
    },
})

export const { 
    setOpenDrawerLeft,
    setOpenDrawerRight,
    setOpenPreviewDRG,
    setOpenSimulatorDRG,
    setOpenSimulatorPolicy
} = layoutControlSlice.actions;

export const getOpenDrawerLeft = (state) => state.layoutControl.openDrawerLeft;
export const getOpenDrawerRight = (state) => state.layoutControl.openDrawerRight;
export const getOpenPreviewDRG = (state) => state.layoutControl.openPreviewDRG;
export const getOpenSimulatorDRG = (state) => state.layoutControl.openSimulatorDRG;
export const getOpenSimulatorPolicy = (state) => state.layoutControl.openSimulatorPolicy;

export default layoutControlSlice.reducer